<template lang="html">

  <section class="load-spinner">
    <div class="custom-modal">
      <b-spinner style="width:3rem;height:3rem;" variant="info" label="Spinning"></b-spinner>
    </div>
  </section>

</template>

<script lang="js">
  export default  {
    name: 'load-spinner',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
}
</script>

<style lang="scss">
  .load-spinner {
    .custom-modal {
      z-index: 100;
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background-color: rgba(0, 0, 0, 0.3);
      display: flex;
      justify-content: center;
      align-items: center;
      [label*="Spi"] {
        width: 3rem;
        height: 3rem;
      }
    }
  }
</style>
